import React, { useState } from 'react';
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonInput,
    IonItem,
    IonLabel,
    IonTextarea,
    IonButton,
    IonToast,
} from '@ionic/react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
    return (
        <>

            <header>
                <div className="header-area">
                    <div className="main-header ">
                        <div className="header-top">
                            <div className="header-social">
                                <a href="https://www.facebook.com/profile.php?id=61577840330706" target='_blank' rel="noreferrer" aria-label="Visit our Facebook profile"><i className="fab fa-facebook"></i></a>
                                <a href="https://x.com/MamasGuidance" target='_blank' rel="noreferrer" aria-label="Visit our Twitter profile"><i className="fab fa-twitter"></i></a>
                                <a href="https://www.youtube.com/channel/UCCAToEWU7aJAVOlTlEX_6XA" target='_blank' rel="noreferrer" aria-label="Visit our Youtube channel"><i className="fab fa-youtube"></i></a>
                                <a href="https://www.instagram.com/mamas.guidance/" target='_blank' rel="noreferrer" aria-label="Visit our Instagram profile"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        <div className="header-bottom  header-sticky">
                            <div className="container-fluid">
                                <div className="row align-items-center">
                                    <div className="col-xl-4 col-md-4">
                                        <div className="logo">
                                            <Link to="/" aria-label="Mamas Guidance is an educational platform offering interactive learning resources— Logical Reasoning, English, Maths, EVS & more—for Nursery through Class 2, plus Olympiad prep for young learners."><img src="assets/logo-500.png" alt="" style={{ 'height': '100px' }} /></Link>
                                        </div>
                                        <div className='siteName text-white font-weight-bold font-25'>
                                            <span className="yellowText" style={{ color: "#95387c" }}>Mamas</span> &nbsp;
                                            <span className="orangeText" style={{ color: "#95387c" }}>Guidance</span>
                                        </div>
                                    </div>
                                    <div className="col-xl-8 col-md-8">
                                        <div className="main-menu f-right d-none d-md-block">
                                            <nav className="classes-menu">
                                                <Link to={'/all-olympiads'}>Olympiad</Link>
                                                <Link to={'/all-classes'}>Start Learning</Link>
                                                <Link to={'/about-us'}>About</Link>
                                                <Link to={'/contact-us'}>Contact</Link>
                                            </nav>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;